<div *ngIf="(isLoggedIn1 | async) && !isChangePasswordRequired " class="sidebar-shell" style="height: calc(100vh - 165px);">
  <!--span>
      <img src="../assets/img/rs.png" class="angular-logo">
    </span-->
  <div style="display: flex; flex-direction: column; justify-content: space-between; height: calc(100vh - 165px);">
    <div style="font-size: 1.2em;" class="menu">
      <p-panelMenu [model]="items" [multiple]="false"></p-panelMenu>
    </div>
    <div class="sidebar-footer">
      <mat-form-field *ngIf="tenants && tenants.length > 1">
        <mat-select (selectionChange)="setTenant($event)" style="width: 200px;"
                    [value]="tenantName">
          <mat-option *ngFor="let tenantName of tenants" [value]="tenantName">{{tenantName}}</mat-option>
        </mat-select>
      </mat-form-field>
      <div *ngIf="accessRequest" mwlConfirmationPopover
           [title]="'Accept Support Access'" [popoverMessage]="'Do you approve Rizkly Support to access your account? '"
           [appendToBody]="true"
           [confirmText]="'Approve'" [cancelText]="'Reject'" placement="bottom" (confirm)="setRequestStatus(1)"
           (cancel)="setRequestStatus(2)">
        <button mat-button>Support Request Pending</button>
      </div>
      <div class="menu-meta-text" style="font-size: 10px; line-height:normal;vertical-align:top;padding-left: 15px;">
        Last login: {{currentUser.previousLoginTime | date : "M/d/y h:mm a"}}</div>
      <button mat-button *ngIf="currentUser" style="vertical-align: bottom;line-height:normal;padding-left:15px;">
        <span class="menu-meta-text">{{getUserName()}}</span>
      </button>
      <button mat-icon-button [matMenuTriggerFor]="menu">
          <span class="icon-settings">
            <svg
              style="vertical-align: text-top"
              xmlns="http://www.w3.org/2000/svg"
              height="447.875"
              width="433.0947"
              viewBox="0 0 433.0947 447.875"
              role="img"
              class="svg-inline--fa fa-cogs fa-w-20"
              data-icon="cogs"
              data-prefix="far"
              focusable="false"
              aria-hidden="true">
              <path
                id="path31"
                d="m 217.11679,447.875 c -23.8,0 -41.6,-3.5 -57.5,-7.5 -10.6,-2.7 -18.1,-12.3 -18.1,-23.3 v -31.7 c -9.4,-4.4 -18.4,-9.6 -26.9,-15.6 l -26.700004,15.4 c -9.599998,5.6 -21.899998,3.8 -29.499998,-4.3 -35.400004,-37.6 -44.200004,-58.6 -57.2000038,-98.5 -3.6,-10.9 1.1,-22.7 10.9999998,-28.4 l 26.8,-15 c -0.9,-10.3 -0.9,-20.7 0,-31.1 l -26.8,-15.1 c -9.9999998,-5.6 -14.5999998,-17.5 -10.9999998,-28.4 13.0999998,-40 21.8999998,-60.9 57.2000038,-98.499999 7.6,-8.1 19.8,-9.9 29.499998,-4.3 l 26.700004,15.4 c 8.5,-6 17.5,-11.2 26.9,-15.6 v -30.2 c 0,-11.1 7.6,-20.8 18.4,-23.300001 44.2,-10.5 70,-10.5 114.3,0 10.8,2.600001 18.4,12.200001 18.4,23.300001 v 30.4 c 9.4,4.4 18.4,9.6 26.9,15.6 l 26.7,-15.4 c 9.7,-5.6 21.9,-3.7 29.6,4.4 26.1,27.900001 48.4,58.499999 56.8,100.299999 2,9.8 -2.4,19.8 -10.9,25.1 l -26.6,16.5 c 0.9,10.3 0.9,20.7 0,31.1 l 26.6,16.5 c 8.4,5.2 12.9,15.2 10.9,24.9 -8.1,40.5 -29.6,71.3 -56.9,100.6 -7.6,8.1 -19.8,9.9 -29.5,4.3 l -26.7,-15.4 c -8.5,6 -17.5,11.2 -26.9,15.6 v 31.7 c 0,11 -7.4,20.6 -18.1,23.3 -15.8,3.8 -33.6,7.2 -57.4,7.2 z m -27.6,-50.7 c 18.3,2.9 36.9,2.9 55.1,0 v -44.8 l 16,-5.7 c 15.2,-5.4 29.1,-13.4 41.3,-23.9 l 12.9,-11 38.8,22.4 c 11.7,-14.4 21,-30.5 27.6,-47.7 l -38.8,-22.4 3.1,-16.7 c 2.9,-15.9 2.9,-32 0,-47.9 l -3.1,-16.7 38.8,-22.4 c -6.6,-17.2 -15.9,-33.3 -27.6,-47.7 l -38.8,22.4 -12.9,-11 c -12.3,-10.5 -26.2,-18.6 -41.3,-23.9 l -16,-5.699998 V 49.775001 c -18.3,-2.9 -36.9,-2.9 -55.1,0 v 44.800001 l -16,5.699998 c -15.2,5.4 -29.1,13.4 -41.3,23.9 l -12.9,11 -38.800002,-22.4 c -11.7,14.4 -21,30.5 -27.600004,47.7 l 38.800002,22.4 -3.1,16.7 c -2.9,15.9 -2.9,32 0,47.9 l 3.1,16.7 -38.800002,22.4 c 6.600004,17.2 15.900004,33.4 27.600004,47.7 l 38.800002,-22.4 12.9,11 c 12.3,10.5 26.2,18.6 41.3,23.9 l 16,5.7 z m 27.1,-85.1 c -22.6,0 -45.2,-8.6 -62.4,-25.8 -34.4,-34.4 -34.4,-90.4 0,-124.8 34.4,-34.4 90.4,-34.4 124.8,0 34.4,34.4 34.4,90.4 0,124.8 -17.3,17.2 -39.9,25.8 -62.4,25.8 z m 0,-128.4 c -10.3,0 -20.6,3.9 -28.5,11.8 -15.7,15.7 -15.7,41.2 0,56.9 15.7,15.7 41.2,15.7 56.9,0 15.7,-15.7 15.7,-41.2 0,-56.9 -7.8,-7.9 -18.1,-11.8 -28.4,-11.8 z"
                />
            </svg>
          </span>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item [routerLink]="['/myProfile']">
          <span>My Profile</span>
        </button>
        <button mat-menu-item (click)="onEditClientProfile()" *ngIf="accountProfileVisible">
          <span>Account Profile</span>
        </button>
        <a mat-menu-item [routerLink]="['/alerts']" (click)="clearAlerts()"
           *ngIf="isAlertsVisible" routerLinkActive="active">Alerts</a>
        <a href="{{this.config.api + '/api/tenants/logs?token=' + userToken }}" mat-menu-item
           *ngIf="isTenantsVisible">
          <span>Get logs</span>
        </a>
        <a href="{{this.config.externalApi + '/api/logs' }}" mat-menu-item
           *ngIf="isTenantsVisible">
          <span>Get API logs</span>
        </a>
        <button mat-menu-item mwlConfirmationPopover *ngIf="terminateSessionsVisible"
                [popoverMessage]="'This will immediately log out all users form all tenants, including yourself. Users will be able to log back in by entering their username and password. Proceed?'"
                [appendToBody]="true"
                [confirmText]="'Yes'" [cancelText]="'No'" placement="left"
                (confirm)="terminateSessions()">
          <span>Terminate All Sessions</span>
        </button>
        <button mat-menu-item (click)="onLogout()">
          <span>Log out</span>
        </button>
      </mat-menu>
    </div>
  </div>
</div>
